<template>
    <div id="home" class="home" v-wechat-title="userType.webSiteTitle">
      <!--头部navbar-->
      <div class="home_top">
        <div class="home_top_nav">
          <div>
            <!--<img class="fl clear" src="../../assets/img/logo.png" alt="企业logo">-->
            <!--<span class="logo_txt">李宁电商ERP系统</span>-->
            <span class="logo_txt">{{userType.webLogoName}}</span>
            <!--<span class="logo_txt">S-SPEED 极速运动</span>-->
            <i class="iconfont icon-biaoti" :class="{'rot90': isCollapse}" @click="collapseBtn()"></i>
          </div>
          <div class="inb list_ctrl">
            同步发货失败订单：
            <span class="mr10" v-if="refundCountInfo.syncFailOrderCount === 0">0笔</span>
            <a class="fcDel mr10" v-if="refundCountInfo.syncFailOrderCount !== 0" @click="toOrderList('showFailOrder')">{{refundCountInfo.syncFailOrderCount}}笔</a>
            待受理售后单：
            <span class="mr10" v-if="refundCountInfo.pendingCount === 0">0笔</span>
            <a class="fcDel mr10" v-if="refundCountInfo.pendingCount !== 0" @click="toAfterSalesOrder(2)">{{refundCountInfo.pendingCount}}笔</a>
            渠道拒绝售后：
            <span class="mr10" v-if="refundCountInfo.rejectCount === 0">0笔</span>
            <a class="fcDel mr10" v-if="refundCountInfo.rejectCount !== 0" @click="toAfterSalesOrder(6)">{{refundCountInfo.rejectCount}}笔</a>
            待换货售后：
            <span class="mr10" v-if="refundCountInfo.waitingExchangeCount === 0">0笔</span>
            <a class="fcDel mr10" v-if="refundCountInfo.waitingExchangeCount !== 0" @click="toAfterSalesOrder('a')">{{refundCountInfo.waitingExchangeCount}}笔</a>
          </div>
          <ul>
            <li @click="addTab('购物车', '/home/car', defaultActive)">
              购物车
              <el-badge v-if="homeGoodsList && homeGoodsList.length > 0" :value="homeGoodsList.length" :max="99" style="margin-top: -10px; margin-left: -5px;">
              </el-badge>
            </li>
            <li class="pr home_user">
              {{userName}}
              <i class="el-icon-arrow-down"></i>
              <i class="el-icon-arrow-up"></i>
              <ul class="home_user_msg">
                <li @click="isShow=true">修改密码</li>
                <li @click="logout()">退出</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--左侧栏-->
      <div id="home_left" class="home_left pr clear" :class="{'w140': !isCollapse}">
        <el-menu class="el-menu-vertical-demo" router
                 :default-active="defaultActive"
                 @open="handleOpen" @close="handleClose" :collapse="isCollapse" :default-openeds="onpened" @select="selects">
          <div v-for="(item, index) in optionList" :key="index">
            <!--有子级-->
            <el-submenu v-if="item.childs.length !== 0" :index="item.Code">
              <template slot="title">
                <i class="iconfont" :class="item.IconCls"></i>
                <span slot="title">{{item.Name}}</span>
              </template>
              <div v-for="(itemChild, itemIndex) in item.childs" :key="itemIndex">
                <!--第二级菜单-->
                <el-menu-item v-if="!itemChild.childs"
                              :index="itemChild.Code"
                              @click="addTab(itemChild.Name, itemChild.Url, itemChild.Code)" style="padding-left: 50px">
                  {{itemChild.Name}}
                </el-menu-item>

                <!--第三级菜单-->
                <el-submenu v-if="itemChild.childs"
                            :index="itemChild.Code">
                  <template slot="title">{{itemChild.Name}}</template>
                  <el-menu-item v-for="(childItem, childIndex) in itemChild.childs"
                                :index="childItem.Code"
                                :key="childIndex">{{childItem.Name}}</el-menu-item>
                </el-submenu>
              </div>

            </el-submenu>
            <!--没有子级-->
            <el-menu-item v-if="item.childs.length === 0" :index="item.Code" @click="noMenu()">
              <i class="iconfont" :class="item.IconCls"></i>
              <span slot="title">{{item.Name}}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>

      <!--右边框-->
      <div class="home_right width-141 clear" :class="{'width-51': isCollapse}">
        <div class="home_right_tabs">
          <el-tabs v-model="rightTabsPosition"
                   type="card"
                   closable
                   @tab-click="handleClick"
                   @tab-remove="removeTab">
            <el-tab-pane name="/home/index">
              <span slot="label"><i class="iconfont icon-home"></i></span>
            </el-tab-pane>
            <el-tab-pane
              v-for="(item) in rightTabsContent"
              :key="item.name"
              :label="item.title"
              :name="item.name">
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="!isLoading" class="home_right_main">
          <keep-alive>
            <router-view/>
          </keep-alive>
        </div>
      </div>

      <!--弹出框-->
      <select-dialog v-if="isShow" :title="'修改密码'" :showType="'forgetPwd'" @cancelbtn="getSelectDialog"></select-dialog>

      <!--加载框之登录超时-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
    </div>
</template>

<script type="es6">
  import SelectDialog from '../public-component/select-dialog';
  import LoadingDialog from '../public-component/loading-dialog';

  export default {
    name: 'home',
    components: {SelectDialog, LoadingDialog},
    computed: {
      homeGoodsList: {
        // getter
        get: function () {
          return this.$store.state.carGoodsList;
        },
        // setter
        set: function (newVal) {
          this.$store.state.carGoodsList = newVal;
          return this.$store.state.carGoodsList;
        }
      },
      rightTabsContent: {
        // getter
        get: function () {
          return this.$store.state.tabs;
        },
        // setter
        set: function (newVal) {
          this.$store.state.tabs = newVal;
          return this.$store.state.tabs;
        }
      },
      rightTabsPosition: {
        get: function () {
          return this.$store.state.tabsPosition;
        },
        set: function (newVal) {
          this.$store.state.tabsPosition = newVal;
          return this.$store.state.tabsPosition;
        }
      },
      refundCountInfo: {
        get: function () {
          return this.$store.state.refundCountInfo;
        },
        set: function (newVal) {
          this.$store.state.refundCountInfo = newVal;
          return this.$store.state.refundCountInfo;
        }
      }
    },
    watch: {
      rightTabsContent: function () {
        // console.log('tabs定位', this.rightTabsPosition);
        // this.rightTabsPosition = val[val.length - 1].name;
        if (this.rightTabsPosition === 0) {
          this.rightTabsPosition = '/home/index';
        }
      }
    },
    data() {
      return {
        userType: {
          companyName: '',
          webUrl: '',
          customerServiceQQ: '',
          supplyWebUrl: '',
          webSiteTitle: '',
          webLogoName: '',
          financeQQ: '',
          clientId: ''
        },  // 用户类型
        userName: '', // 登录后用户名
       /* refundCountInfo: {
          pendingCount: 0,
          rejectCount: 0,
          waitingExchangeCount: 0
        }, // 售后单类型统计 */
        optionList: [], // 有份上下级的列表
        defaultActive: '', // 刷新默认选中
        onpened: [], // 左侧栏刷新选中的时候那一栏打开
        options: [
          {name: '平台公告列表', route: '/home/p_list'},
          {name: '供应商公告列表', route: '/home/s_list'},
          {name: '货品列表', route: '/home/g_list'},
          {name: '宝贝列表', route: '/home'},
          {name: '渠道列表', route: '/home'},
          {name: '渠道库存查询', route: '/home'},
          {name: '货号库存查询', route: '/home'},
          {name: '活动锁库', route: '/home'},
          {name: '成本价查询', route: '/home'},
          {name: '店铺设置', route: '/home/s_setup'},
          {name: '数据下载', route: '/home/s_download'},
          {name: '供应商绑定', route: '/home/s_binding'},
          {name: '用户设置', route: '/home/u_setup'},
          {name: '角色设置', route: '/home/r_setup'}
        ], // 左侧栏路由目录
        isCollapse: false, // 侧边栏：展开=false  缩放=true
        // rightTabsPosition: '/home/index', // tabs定位
        // rightTabsContent: [], // tabs数组对象
        tabIndex: 2,
        // carGoodsList: null, // 购物车数据
        isShow: false, // 弹出框显示隐藏
        isLoading: false, // 是否显示登录超时框
        loadingType: 'NOP' // 加载类型  NOP=空操作，用于加载  loginTimeout=加载超时
      }
    },
    methods: {
      // 左侧栏展开隐藏
      collapseBtn() {
        this.isCollapse = !this.isCollapse;
      },

      // 左侧栏没有路由的菜单点击后的效果
      noMenu() {
        alert('此菜单还在开发中，敬请期待......');
        // console.log(this.$route);
        // location.history(-1);
        this.$router.back(-1);
      },

      // 点击左侧栏增加tabs
      addTab(targetName, tabsIndex, activeIndex) { // targetName=tabs添加头title   tabsIndex=路由，也为tabs的name   activeIndex=菜单选中
        this.isLoginTimeout();
        sessionStorage.setItem('isRefresh', 'true');
        if (tabsIndex === 'aa') {
          this.noMenu();
        } else {
          this.rightTabsPosition = tabsIndex;
          this.defaultActive = activeIndex;
          /**
           *  左侧栏点击进入对应的路由
           * */
          this.$router.push({
            path: tabsIndex
          });
          /**
           *  判断tabs是否有重复
           * */
          let flag = false;
          for (let i = 0; i < this.rightTabsContent.length; i++) {
            if (this.rightTabsContent[i].title === targetName) {
              flag = true;
              return flag;
            }
          }
          if (!flag) {
            this.rightTabsContent.push({
              title: targetName,
              name: tabsIndex,
              content: this.$route.path
            });
            this.rightTabsPosition = tabsIndex;
          }
        }
        // sessionStorage.setItem('tabs', JSON.stringify(this.rightTabsContent));
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 移除tabs
      removeTab(targetName) {
        // console.log(targetName);
        let tabs = this.rightTabsContent;
        let activeName = this.rightTabsPosition;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        /**
         *  tabs重新定位
         *  路由重新跳转/刷新
         * */
        this.rightTabsPosition = activeName;
        this.rightTabsContent = tabs.filter(tab => tab.name !== targetName);
        this.$router.push({
          path: this.rightTabsPosition
        });
        // sessionStorage.setItem('tabs', JSON.stringify(this.rightTabsContent));
        this.$store.commit('updateTabs', this.rightTabsContent);
        if (this.rightTabsContent.length === 0) {
          this.rightTabsPosition = '/home/index';
          this.$router.push({
            path: this.rightTabsPosition
          });
        }
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 点击tabs框
      handleClick() {
        // console.log(JSON.parse(sessionStorage.getItem('tabs')));
        this.isLoginTimeout();
        sessionStorage.setItem('isRefresh', 'false');
        // this.rightTabsContent = JSON.parse(sessionStorage.getItem('tabs'));
        let rightTabsPosition = this.rightTabsPosition;
        if (this.rightTabsPosition === '/home/car') {
          rightTabsPosition = '/home/car?clear=false'; // 为了清空地址栏那些
        }
        this.$router.push({
          path: rightTabsPosition
        });
      },

      // 菜单激活回调：index: 选中菜单项的 index, indexPath: 选中菜单项的 index path
      selects(index, indexPath) {
        this.onpened = indexPath;
        if (indexPath.length > 2) { // 为了判断两个父级同时展开的bug
          if (indexPath[0].indexOf('-') === indexPath[indexPath.length - 1].indexOf('-')) {
            this.onpened = indexPath.slice(0, indexPath.length - 1)
          }
        }
      },

      // 获取分销网站的客户个性化信息
      getWebClienData() {
        this.$axios.get(this.Global.getWebClienData).then((res) => {
          if (res && !res.data.errorMsg.length) {
            this.userType = res.data.resData;
            sessionStorage.setItem('financeQQ', this.userType.financeQQ);
          }
        });
      },

      // 退出登录
      logout() {
        sessionStorage.clear('token');
        sessionStorage.clear('userId');
        sessionStorage.clear('userName');
        sessionStorage.clear('loginTimeout');
        sessionStorage.clear();
        this.$router.push({
          path: '/'
        });
      },

      // 接收弹出框传送的数据
      getSelectDialog(e) {
        this.isShow = e.isShow;
      },

      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },

      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },

      // 判断是否登录超时，sessionStorage.getItem('loginTimeout')是否为‘true’
      isLoginTimeout() {
        // if (sessionStorage.getItem('loginTimeout') === 'true' || (typeof sessionStorage.getItem('loginTimeout')) === 'object') {
        if (sessionStorage.getItem('loginTimeout') === 'true') {
          this.isLoading = true;
          this.loadingType = 'loginTimeout';
          this.$router.push({
            path: '/home/lto'
          });
        }
      },

      // 获取当前登录用户的分销商的购物车信息
      getShoppingCartData() {
        this.$axios.get(this.Global.getShoppingCartData).then((res) => {
          if (!res.data.errorMsg.length) {
            this.homeGoodsList = res.data.resData;
            // localStorage.setItem("carGoodsList", JSON.stringify(res.data.resData));
            sessionStorage.setItem('carGoodsList', JSON.stringify(res.data.resData));
          }
        });
      },

      // 获取分销商的售后统计数据
      getRefundCountInfo() {
        this.$axios.get(this.Global.getRefundCountInfo).then((res) => {
          if (!res.data.errorMsg.length) {
            this.refundCountInfo = res.data.resData.refundCountInfo;
            this.$store.commit('updateAfterOrder', this.refundCountInfo);
          }
        });
      },

      // showFailOrder=显示同步发货失败订单
      toOrderList(status) {
        this.$router.push({
          path: '/home/o_list',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '细化订单列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '细化订单列表',
            name: '/home/o_list',
            content: this.$route.fullPath
          });
        }
        this.rightTabsPosition = '/home/o_list';
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', this.rightTabsPosition);
      },

      // 售后单  status  2=待受理  3=待退货  4=待收货  5=待退款  6=拒绝售后  7=售后成功  8=售后关闭  a=待换货售后
      toAfterSalesOrder(status) {
        this.$router.push({
          path: '/home/as_list',
          query: {
            status: status
          }
        });
        let index = -1;
        index = this.rightTabsContent.findIndex(item => {
          return item.title === '售后列表';
        });
        if (index === -1) {
          this.rightTabsContent.push({
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        } else {
          this.rightTabsContent.splice(index, 1, {
            title: '售后列表',
            name: '/home/as_list',
            content: this.$route.fullPath
          });
        }
        this.$store.commit('updateTabs', this.rightTabsContent);
        this.$store.commit('updateTabsPosition', '/home/as_list');
      }
    },
    created() {
      // 获取分销网站的客户个性化信息
      this.getWebClienData();
      // 获取登录后用户名
      this.userName = sessionStorage.getItem('userName');
      // 获取左侧栏菜单
      this.$axios.get(this.Global.getMenuInfoUrl).then((res) => {
        console.log(res);
        let data;
        if (!res) { // 401状态进入
          sessionStorage.setItem('loginTimeout', 'true');
          this.isLoginTimeout();
          this.isLoading = true;
          this.loadingType = 'loginTimeout';
          return;
        }

        this.isLoading = false;
        if (!res.data.errorMsg.length) {
          data = res.data.resData;
          // 获取菜单第一层
          for (let i = 0; i < data.length; i++) {
            if (data[i].Rank === '1') {
              this.optionList.push(data[i]);
              // data.splice(i, 1);
            }
          }

          // 获取菜单第二层
          for (let y = 0; y < this.optionList.length; y++) {
            this.$set(this.optionList[y], 'childs', []);
            for (let x = 0; x < data.length; x++) {
              if (this.optionList[y].Code === data[x].PCode) {
                this.optionList[y].childs.push(data[x]);
              }
            }
          }

          // 获取菜单第三层
          let childArr = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].Rank === '3') {
              for (let x = 0; x < this.optionList.length; x++) {
                if (this.optionList[x].childs.length !== 0) {
                  for (let y = 0; y < this.optionList[x].childs.length; y++) {
                    this.$set(this.optionList[x].childs[y], 'childs', []);
                    if (this.optionList[x].childs[y].Code === data[i].PCode) {
                      childArr.push(data[i]);
                      this.optionList[x].childs[y].childs = childArr;
                    }
                  }
                }
              }
            }
          }

          // 刷新时以当前路由做为tab加入tabs
          let flag = false;
          let route;
          if (this.$route.path === '/home/car') {
            route = '/home/r_order';
          } else {
            route = this.$route.path;
          }
          for (let i = 0; i < this.optionList.length; i++) {
            for (let x = 0; x < this.optionList[i].childs.length; x++) {
              // console.log(this.$route.path);
              this.$store.commit('clearTabs');
              this.rightTabsPosition = '/home/index';
              if (route === this.optionList[i].childs[x].Url) {
                flag = true;
                // this.addTab(this.optionList[i].childs[x].Name, this.optionList[i].childs[x].Url, this.optionList[i].childs[x].Code);
                // this.addTab(this.optionList[i].childs[x].Name, this.$route.fullPath, this.optionList[i].childs[x].Code);
                this.$store.commit('clearTabs');
                this.addTab(this.optionList[i].childs[x].Name, route, this.optionList[i].childs[x].Code);

                /* 刷新默认选中左侧栏 */
                // this.defaultActive = this.optionList[i].childs[x].Code;

                /* 一进入就定位左侧栏打开 */
                this.onpened.push(this.optionList[i].Code);
                this.onpened.push(this.optionList[i].childs[x].Code);
                return flag;
              }
            }
          }
          if (!flag) {
            this.rightTabsPosition = 0;
          }
        }
      }, (err) => {
        // console.log(err);
        this.isLoginTimeout();
      });

      // 获取分销商的售后统计数据
      this.getRefundCountInfo();
      setInterval(this.getRefundCountInfo, 1000 * 60 * 30);

      // 获取当前登录用户的分销商的购物车信息
      this.getShoppingCartData();
    },
    mounted() {
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = false;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/base-color";
.home {
  width: 100%;
  min-width: 1165px;
  height: 100%;

  .home_top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: $navbar;

    .home_top_nav {
      width: 98%;
      margin: auto;
      color: #fff;

      &>div {
        display: inline-block;

        .icon-biaoti {
          transition: all 0.25s linear;
          font-size: 28px;

          &.rot90 {
            transform: rotate(90deg);
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .logo_txt {
        font-size: 20px;
        font-weight: bold;
        float: left;
        font-family: '幼圆';
        line-height: 46px;
      }

      .list_ctrl {
        width: calc(100% - 430px);
        text-align: center;
        font-size: 16px;
        height: 36px;
      }

      img {
        margin: 2px 10px 0;
      }

      &>ul {
        display: inline-block;
        float: right;

        &>li {
          display: inline-block;
          float: left;
          padding-left: 10px;
          padding-right: 10px;

          .el-icon-arrow-down {
            display: inline-block;
          }
          .el-icon-arrow-up {
            display: none;
          }

          &:hover {
            cursor: pointer;
            /*background-color: rgba(255,255,255, .4);*/

            &.home_user {
              &>ul {
                display: inline-block;
              }

              .el-icon-arrow-down {
                display: none;
              }
              .el-icon-arrow-up {
                display: inline-block;
              }
            }
          }

          .icon-sey-letter-a, .icon-skin {
            font-size: 22px;
          }

          ul {
            display: none;
            position: absolute;
            top: 50px;
            right: 0;
            z-index: 997;
            box-shadow: 0 0 8px #999;
            color: #000000;
            background-color: #ffffff;

            li {
              width: 120px;
              height: 40px;
              line-height: 40px;
              text-align: center;

              &:hover {
                cursor: pointer;
                background-color: rgba(0,0,0, .1);
              }
            }
          }
        }
      }
    }
  }

  .home_left {
    /* width: 200px; */
    height: calc(100% - 55px);
    margin-top: 5px;
    overflow-x: hidden;
    overflow-y: auto;
    display: inline-block;
    /* background-color: $navLeft; */
    /* background-color: $navbar; */
    background-color: $cfff;
    color: $cfff;
    border-right: 1px solid $bgC;
    float: left;

    i {
      font-size: 20px;
      margin-right: 5px;
      color: $cfff;
    }

    &::-webkit-scrollbar {
      display: none; // 隐藏滚动条 -webkit-scrollbar, 这种方式不兼容 火狐 和 IE
    }

    .el-menu {
      border-right: none;
    }

    .el-menu--collapse {
      width: 50px!important;
    }
  }

  .home_right {
    display: inline-block;
    height: calc(100% - 50px);
    float: left;

    &.width-141 {
      width: calc(100% - 141px);
    }

    &.width-51 {
      width: calc(100% - 51px);
    }

    .home_right_tabs {
      background-color: #fff;
    }

    .home_right_main {
      /*width: 99%;*/
      height: calc(100% - 50px);
      /*margin: auto;*/
      margin: 0 5px;
      padding: 5px 0;
    }
  }

  /*左侧栏选中时的背景颜色*/
  .el-menu-item.is-active {
    /*color: #409eff;*/
    /* background-color: #152547; */
    background-color: #ddd;
  }
}
</style>
<style lang="scss">
  .home_right_tabs {
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-closable:first-child:hover {
           padding-left: 20px!important;
           padding-right: 20px!important;
         }

    .el-tabs--card>.el-tabs__header {
      margin: 1px 0 0!important;
    }

    /*tabs第一个首页不可移除，隐藏X删除符号*/
    #tab-\/home {
      &>span:nth-child(2) {
        display: none!important;
      }
    }

    #tab-\/home\/index {
      &>span:nth-child(2) {
        display: none!important;
      }
    }

/*    #tab-1 {
      span {
        display: none;
      }
    }*/
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue